/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateChainItem } from './CertificateChainItem';
import {
    CertificateChainItemFromJSON,
    CertificateChainItemFromJSONTyped,
    CertificateChainItemToJSON,
} from './CertificateChainItem';
import type { Logo } from './Logo';
import {
    LogoFromJSON,
    LogoFromJSONTyped,
    LogoToJSON,
} from './Logo';

/**
 * Related brand credential
 * @export
 * @interface BrandCredentialDetailedDto
 */
export interface BrandCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    type?: BrandCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    status?: BrandCredentialDetailedDtoStatusEnum;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * 
     * @type {Array<CertificateChainItem>}
     * @memberof BrandCredentialDetailedDto
     */
    certificateChain?: Array<CertificateChainItem>;
    /**
     * 
     * @type {string}
     * @memberof BrandCredentialDetailedDto
     */
    brandName?: string;
    /**
     * 
     * @type {Logo}
     * @memberof BrandCredentialDetailedDto
     */
    logo?: Logo;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandCredentialDetailedDto
     */
    categories?: Array<string>;
}


/**
 * @export
 */
export const BrandCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type BrandCredentialDetailedDtoTypeEnum = typeof BrandCredentialDetailedDtoTypeEnum[keyof typeof BrandCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const BrandCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type BrandCredentialDetailedDtoStatusEnum = typeof BrandCredentialDetailedDtoStatusEnum[keyof typeof BrandCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the BrandCredentialDetailedDto interface.
 */
export function instanceOfBrandCredentialDetailedDto(value: object): boolean {
    return true;
}

export function BrandCredentialDetailedDtoFromJSON(json: any): BrandCredentialDetailedDto {
    return BrandCredentialDetailedDtoFromJSONTyped(json, false);
}

export function BrandCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'certificateChain': json['certificateChain'] == null ? undefined : ((json['certificateChain'] as Array<any>).map(CertificateChainItemFromJSON)),
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'logo': json['logo'] == null ? undefined : LogoFromJSON(json['logo']),
        'categories': json['categories'] == null ? undefined : json['categories'],
    };
}

export function BrandCredentialDetailedDtoToJSON(value?: BrandCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'certificateChain': value['certificateChain'] == null ? undefined : ((value['certificateChain'] as Array<any>).map(CertificateChainItemToJSON)),
        'brandName': value['brandName'],
        'logo': LogoToJSON(value['logo']),
        'categories': value['categories'],
    };
}

